import PropTypes from 'prop-types'

import {tagColors} from '../../../common/colors.js'
import {toggleTag} from '../createOrderActions.js'
import Icon from '../../../common/icons/Icon.js'

export default function Tag({tag, canRemove}) {
  return (
    <li
      className="list__item--inline-block list__item--tag"
      style={tagColors(tag.color)}
    >
      <strong className="tag-name inline-block v-align-middle">
        {tag.name}
      </strong>
      {canRemove && (
        <button
          className="btn btn--remove-tag"
          type="button"
          onClick={() => toggleTag(tag.id, false)}
        >
          <Icon name="times" />
        </button>
      )}
    </li>
  )
}

Tag.propTypes = {
  tag: PropTypes.object.isRequired,
  canRemove: PropTypes.bool.isRequired,
}
